"use strict";

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.default = sortObject;
/**
 *
 */
function sortObject(object, order) {
	var sorted = {};

	order.forEach(function (key) {
		if (key in object) {
			sorted[key] = object[key];
		}
	});

	return sorted;
}